import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';

import CreateDepartmentRole from './CreateDepartmentRole';
import CreateTeamRole from './CreateTeamRole';
import GroupSelector from './GroupSelector';

export default function CreateGroupRole(props: {
	user: graphql.User;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	refetch: () => Promise<any>;
	onCancel: () => void;
	onCreate: () => void;
}) {
	const { t } = useTranslation();

	const [group, setGroup] = useState<graphql.Group>();

	return group ? (
		group.type === graphql.GroupType.Department ? (
			<CreateDepartmentRole
				source={props.user}
				target={group}
				refetch={props.refetch}
				onCancel={() => {
					setGroup(undefined);
					props.onCancel();
				}}
				onCreate={props.onCreate}
			/>
		) : (
			<CreateTeamRole
				source={props.user}
				target={group}
				refetch={props.refetch}
				onCancel={() => {
					setGroup(undefined);
					props.onCancel();
				}}
				onCreate={props.onCreate}
			/>
		)
	) : (
		<GroupSelector
			placeholder={t('settings.employees.roles.create.group.placeholder', {
				name: props.user.firstName,
			})}
			onChange={(group) => setGroup(group as graphql.Group)}
		/>
	);
}
